<template>
  <div>
      <b-modal
          centered
          no-close-on-backdrop
          no-close-on-esc
          ref="modal-idcard"
          id="modal-idcard"
          no-stacking
          hide-footer
      >
          <template slot="modal-header">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-12">
                  <h3 class="mb-0">
                    ฟอร์มยืนยันผู้ใช้บริการส่งพัสดุ
                    <small>( บัตรประชาชน )</small>
                  </h3>
                </div>
              </div>
            </div>
          </template>
          <card shadow type="secondary" class="m--4">
            <template>
                <h6 class="heading-small text-muted mb-2">ข้อมูลบัตรประชาชนผู้ส่งพัสดุ</h6>
                <div>
                  <div class="row">
                    <div class="col-md-12">
                      <b-form-group label="ประเภทลูกค้า">
                        <b-form-radio-group v-model="sender.customer_type">
                          <b-form-radio value="0">บุคคลธรรมดา</b-form-radio>
                          <b-form-radio value="1">นิติบุคคล</b-form-radio>
                        </b-form-radio-group>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12" v-if="$THEME.name == 'quickexpress'">
                      <div class="form-group">
                          <label floater>
                            <small class="text-danger">*</small> หมายเลขโทรศัพท์
                          </label>
                          <autocomplete
                            :search="searchSenderDetails"
                            @submit="onSubmitSenders"
                            @input="sender.tel = $event.target.value"
                            :value="sender.tel"
                            ref="sender_tel"
                            class="senderTel"
                            :class="{ 'is-invalid': submitAddIdCard && $v.sender.tel.$error }"
                          >
                            <template v-slot:result="{ result, props }">
                              <li v-bind="props">
                                <h6 class="d-flex  align-items-center">
                                  {{result.name}} <i class="fas fa-angle-double-right px-1"></i> {{result.customer_type == 0 ?'บุคคลธรรมดา':'นิติบุคคล'}}  <i class="fas fa-angle-double-right px-1"></i>{{result.tel}} <i class="fas fa-angle-double-right px-1"></i> {{result.state}} {{result.district}} {{result.province}}
                                </h6 >
                              </li>
                            </template>

                          </autocomplete>
                          <div
                          v-if="submitAddIdCard && !$v.sender.tel.required"
                          class="error invalid-feedback d-block"
                          >กรุณากรอกหมายเลขโทรศัพท์</div>
                          <div v-if="submitAddIdCard && !$v.sender.tel.numeric" class="error invalid-feedback d-block">กรุณากรอกเฉพาะตัวเลข</div>
                          <div
                            class="error invalid-feedback d-block"
                            v-if="submitAddIdCard && !$v.sender.tel.minLength"
                          >กรุณากรอก"หมายเลขโทรศัพท์" อย่างน้อย {{$v.sender.tel.$params.minLength.min}} หลัก</div>
                          <div
                            class="invalid-feedback d-block"
                            v-if="!$v.sender.tel.maxLength"
                          >กรุณากรอก"หมายเลขโทรศัพท์" ไม่เกิน {{$v.sender.tel.$params.maxLength.max}} หลัก</div>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label floater>
                          <small class="text-danger">*</small> ชื่อ-นามสกุล / ชื่อบริษัท
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          ref="sender_name"
                          v-model="sender.name"
                          :autofocus="'autofocus'"
                          :class="{ 'is-invalid': submitAddIdCard && $v.sender.name.$error }"
                        />

                        <div
                          v-if="submitAddIdCard && !$v.sender.name.required"
                          class="invalid-feedback"
                        >กรุณากรอกชื่อ-นามสกุล</div>
                        <div
                          class="error invalid-feedback"
                          v-if="!$v.sender.name.maxLength"
                        >กรุณากรอก"ชื่อ-นามสกุล" ไม่เกิน {{$v.sender.name.$params.maxLength.max}} ตัวอักษร</div>
                      </div>
                    </div>
                    <div class="col-lg-6" ref="Sender">
                      <div class="form-group">
                        <label floater>
                          <small class="text-danger" v-if="$THEME.optionalDOB">*</small> วันเกิด
                          <small>(วัน/เดือน/พ.ศ.)</small>
                        </label>
                        <input
                          type="text"
                          ref="sender_birthday"
                          v-model="sender.birthday"
                          placeholder="DD/MM/YYYY"
                          v-on:keyup="$emit('formatDate')"
                          class="form-control"
                          :class="{ 'is-invalid': (submitAddIdCard && $v.sender.birthday.$error) || errorBirthday }"
                        />

                        <div
                          v-if="submitAddIdCard && !$v.sender.birthday.required"
                          class="invalid-feedback"
                        >กรุณากรอกวันเกิด</div>
                        <div
                          class="error invalid-feedback"
                          v-if="!$v.sender.birthday.minLength"
                        >กรุณากรอก"วันเกิด"ให้ถูกต้อง</div>
                        <div
                          class="error invalid-feedback"
                          v-if="!$v.sender.birthday.maxLength"
                        >กรุณากรอก"วันเกิด"ให้ถูกต้อง</div>
                        <small
                          v-if="errorBirthday"
                          class="text-danger"
                        >กรุณากรอก"วันเกิด"ให้ถูกต้อง</small>
                      </div>
                    </div>
                    <div class="col-lg-12" v-if="$THEME.name != 'quickexpress'">
                      <div class="form-group">
                          <label floater>
                            <small class="text-danger">*</small> หมายเลขโทรศัพท์
                          </label>
                          <autocomplete
                            :search="searchSenderDetails"
                            @submit="onSubmitSenders"
                            @input="sender.tel = $event.target.value"
                            :value="sender.tel"
                            ref="sender_tel"
                            class="senderTel"
                            :class="{ 'is-invalid': submitAddIdCard && $v.sender.tel.$error }"
                          >
                            <template v-slot:result="{ result, props }">
                              <li v-bind="props">
                                <h6 class="d-flex  align-items-center">
                                  {{result.name}} <i class="fas fa-angle-double-right px-1"></i> {{result.customer_type == 0 ?'บุคคลธรรมดา':'นิติบุคคล'}}  <i class="fas fa-angle-double-right px-1"></i>{{result.tel}} <i class="fas fa-angle-double-right px-1"></i> {{result.state}} {{result.district}} {{result.province}}
                                </h6 >
                              </li>
                            </template>

                          </autocomplete>
                          <div
                          v-if="submitAddIdCard && !$v.sender.tel.required"
                          class="error invalid-feedback d-block"
                          >กรุณากรอกหมายเลขโทรศัพท์</div>
                          <div v-if="submitAddIdCard && !$v.sender.tel.numeric" class="error invalid-feedback d-block">กรุณากรอกเฉพาะตัวเลข</div>
                          <div
                            class="error invalid-feedback d-block"
                            v-if="submitAddIdCard && !$v.sender.tel.minLength"
                          >กรุณากรอก"หมายเลขโทรศัพท์" อย่างน้อย {{$v.sender.tel.$params.minLength.min}} หลัก</div>
                          <div
                            class="invalid-feedback d-block"
                            v-if="!$v.sender.tel.maxLength"
                          >กรุณากรอก"หมายเลขโทรศัพท์" ไม่เกิน {{$v.sender.tel.$params.maxLength.max}} หลัก</div>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label floater>
                          <small class="text-danger">*</small> หมายเลขบัตรประชาชน/หมายเลข Passport
                        </label>

                        <input
                          type="text"
                          ref="sender_id_no"
                          v-model="sender.id_no"
                          class="form-control"
                          :class="{ 'is-invalid': submitAddIdCard && ($v.sender.id_no.$error || errorIdCard) }"
                          @change="$emit('checkIdNo')"
                        />

                        <div
                          v-if="submitAddIdCard && !$v.sender.id_no.required"
                          class="invalid-feedback"
                        >กรุณากรอกหมายเลขบัตรประชาชน/หมายเลข Passport</div>
                        <div
                          class="error invalid-feedback"
                          v-if="!$v.sender.id_no.minLength"
                        >กรุณากรอก"หมายเลขบัตรประชาชน/หมายเลข Passport" อย่างน้อย {{$v.sender.id_no.$params.minLength.min}} หลัก</div>
                        <div
                          class="error invalid-feedback"
                          v-if="!$v.sender.id_no.maxLength"
                        >กรุณากรอก"หมายเลขบัตรประชาชน/หมายเลข Passport" ไม่เกิน {{$v.sender.id_no.$params.maxLength.max}} หลัก</div>
                        <small
                          v-if="errorIdCard"
                          class="text-danger"
                        >กรุณากรอกหมายเลขบัตรประชนชนให้ถูกต้อง</small>
                        <!-- <small
                          v-if="errorPassport"
                          class="text-danger"
                        >กรุณากรอกหมายเลข Passport ให้ถูกต้อง</small>-->
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label floater>
                          <small class="text-danger">*</small> ที่อยู่
                        </label>

                        <input
                          type="text"
                          ref="sender_address"
                          class="form-control"
                          v-model="sender.address"
                          :class="{ 'is-invalid': submitAddIdCard && $v.sender.address.$error }"
                        />

                        <div
                          v-if="submitAddIdCard && !$v.sender.address.required"
                          class="invalid-feedback"
                        >กรุณากรอกที่อยู่</div>
                        <div
                          class="error invalid-feedback"
                          v-if="!$v.sender.address.maxLength"
                        >กรุณากรอก"ที่อยู่" ไม่เกิน {{$v.sender.address.$params.maxLength.max}} ตัวอักษร</div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-6">
                      <div class="form-group">
                        <label floater>
                          <small class="text-danger">*</small> ตำบล/แขวง
                        </label>
                        <AutocompletesAddress
                          ref="sender_state"
                          :queryInput="sender.state"
                          :adsTypes="'sub-district'"
                          :class="{ 'is-invalid': submitAddIdCard && $v.sender.state.$error }"
                          @input="sender.state = $event.target.value"
                          @select:item="$emit('onSubmitAddress' , $event ,'sender' )">
                        </AutocompletesAddress>
                        <div
                          v-if="submitAddIdCard && !$v.sender.state.required"
                          class="invalid-th-address"
                        >กรุณากรอกตำบล/แขวง</div>
                        <div
                          class="invalid-th-address"
                          v-if="!$v.sender.state.maxLength"
                        >กรุณากรอก"ตำบล/แขวง" ไม่เกิน {{$v.sender.state.$params.maxLength.max}} ตัวอักษร</div>
                      </div>
                      <!-- ตำบล/แขวง -->
                    </div>
                    <div class="col-12 col-md-6 col-lg-6">
                      <div class="form-group">
                        <label floater>
                          <small class="text-danger">*</small> อำเภอ/เขต
                        </label>
                        {{ $v.sender.district.$error }}
                        <AutocompletesAddress
                          ref="sender_district"
                          :queryInput="sender.district"
                          :adsTypes="'district'"
                          :class="{ 'is-invalid': submitAddIdCard && $v.sender.district.$error }"
                          @input="sender.district = $event.target.value"
                          @select:item="$emit('onSubmitAddress' , $event ,'sender' )">
                        </AutocompletesAddress>
                        <div
                          v-if="submitAddIdCard && !$v.sender.district.required"
                          class="invalid-th-address"
                        >กรุณากรอกอำเภอ/เขต</div>
                        <div
                          class="invalid-th-address"
                          v-if="!$v.sender.district.maxLength"
                        >กรุณากรอก"อำเภอ/เขต" ไม่เกิน {{$v.sender.district.$params.maxLength.max}} ตัวอักษร</div>
                      </div>
                      <!-- อำเภอ/เขต -->
                    </div>
                    <div class="col-12 col-md-6 col-lg-6">
                      <div class="form-group">
                        <label floater>
                          <small class="text-danger">*</small> จังหวัด
                        </label>
                        <AutocompletesAddress
                          ref="sender_province"
                          :queryInput="sender.province"
                          :adsTypes="'province'"
                          :class="{ 'is-invalid': submitAddIdCard && $v.sender.province.$error }"
                          @input="sender.province = $event.target.value"
                          @select:item="$emit('onSubmitAddress' , $event ,'sender' )">
                        </AutocompletesAddress>
                        <div
                          v-if="submitAddIdCard && !$v.sender.province.required"
                          class="invalid-th-address"
                        >กรุณากรอกจังหวัด</div>
                        <div
                          class="invalid-th-address"
                          v-if="!$v.sender.province.maxLength"
                        >กรุณากรอก"จังหวัด" ไม่เกิน {{$v.sender.district.$params.maxLength.max}} ตัวอักษร</div>
                      </div>
                      <!-- จังหวัด -->
                    </div>

                    <div class="col-lg-6">
                      <div class="form-group addressinput-zipcode-pos">
                        <label floater>
                          <small class="text-danger">*</small> รหัสไปรษณีย์
                        </label>
                        <AutocompletesAddress
                          ref="sender_postcode"
                          :queryInput="sender.postcode"
                          :adsTypes="'postcode'"
                          :class="{ 'is-invalid': submitAddIdCard && $v.sender.postcode.$error }"
                          @input="sender.postcode = $event.target.value"
                          @select:item="$emit('onSubmitAddress' , $event ,'sender' )">
                        </AutocompletesAddress>
                        <div
                          class="invalid-th-address"
                          v-if="submitAddIdCard && !$v.sender.postcode.required"
                        >กรุณากรอกรหัสไปรษณีย์</div>
                        <div
                          class="error invalid-th-address"
                          v-if="submitAddIdCard && !$v.sender.postcode.minLength"
                        >กรุณากรอก"รหัสไปรษณีย์" {{$v.sender.postcode.$params.minLength.min}} หลัก</div>
                        <div
                          class="error invalid-th-address"
                          v-if="submitAddIdCard && !$v.sender.postcode.maxLength"
                        >กรุณากรอก"รหัสไปรษณีย์" {{$v.sender.postcode.$params.maxLength.max}} หลัก</div>
                        <div
                          class="error invalid-th-address"
                          v-if="submitAddIdCard && !$v.sender.postcode.numeric"
                        >กรุณากรอกเฉพาะตัวเลข</div>
                      </div>
                      <!-- รหัสไปรษณีย์ -->
                    </div>
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label floater>เลขประจำตัวผู้เสียภาษี</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="sender.tax"
                          :class="{ 'is-invalid': submitAddIdCard && $v.sender.tax.$error }"
                        />
                        <div
                          class="error invalid-feedback"
                          v-if="submitAddIdCard && !$v.sender.tax.numeric"
                        >กรุณากรอกเฉพาะตัวเลข</div>
                        <div
                          class="error invalid-feedback"
                          v-if="!$v.sender.tax.maxLength"
                        >กรุณากรอก"เลขประจำตัวผู้เสียภาษี" ไม่เกิน {{$v.sender.tax.$params.maxLength.max}} ตัวอักษร</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-4 w-100 text-right">
                  <b-button
                      variant="secondary"
                      class="mx-3"
                      @click="$emit('close')"
                  >
                      ยกเลิก
                  </b-button>
                  <b-button
                    type="submit"
                    class="w-25"
                    variant="success"
                    @click="$emit('checkIdCard' , preBarcode)"
                  >ยืนยัน</b-button>
                </div>
            </template>
          </card>
      </b-modal>
  </div>
</template>

<script>
import {
required,
requiredIf,
minLength,
maxLength,
numeric,
} from "vuelidate/lib/validators"
import moment from "moment";
import AutocompletesAddress from '@/components/Autocomplete/AddressTH/AutocompleteAddressTH'

export default {
  props:{
      sender: Object,
      preBarcode: String,
      errorBirthday: Boolean,
      errorIdCard: Boolean,
      searchSenderDetails: Function
  },
  components:{
      AutocompletesAddress
  },
  data(){
      return {
          submitAddIdCard: false,
      }
  },
  validations:{
      sender: {
          id_no: {
              required,
              minLength: minLength(7),
              maxLength: maxLength(30)
          },
          name: { required , maxLength: maxLength(50)},
          tel: {
              required,
              numeric,
              minLength: minLength(9),
              maxLength: maxLength(15)
          },
          birthday: {
              required: requiredIf(function (state) {
                return state.birthday.length > 0 && this.$THEME.optionalDOB
              }),
              minLength: minLength(8),
              maxLength: maxLength(10)
          },
          address: { required , maxLength: maxLength(200) },
          district: { required , maxLength: maxLength(50)},
          state: { required , maxLength: maxLength(50)},
          province: { required , maxLength: maxLength(50)},
          postcode: {
              required,
              numeric,
              minLength: minLength(5),
              maxLength: maxLength(5)
          },
          tax: { numeric , maxLength: maxLength(50) }
      },
  },
  methods: {
      onSubmitSenders(result) {
          this.sender.tel = result.tel
          this.sender.name = result.name
          this.sender.id_no = result.id_no
          this.sender.tax = result.tax
          this.sender.customer_type = result.customer_type
          this.sender.birthday = result.birthday!='0000-00-00 00:00:00'?moment( result.birthday ).add(543, 'Y').format("DD/MM/YYYY"):''
          this.sender.address = result.address
          this.sender.district = result.district
          this.sender.state = result.state
          this.sender.province = result.province
          this.sender.postcode = result.postcode
      },
  },
}
</script>
